import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/common/Layout";
import Dashboard from "@/pages/Dashboard";
import Blocks from "@/pages/Blocks";
import Transactions from "@/pages/Transactions";
import BlockDetail from "@/pages/BlockDetail";
import TxDetail from "@/pages/TxDetail";
import AddressDetail from "@/pages/AddressDetail";
import Validators from "@/pages/Validators";
import Network from "@/pages/Network";
import Tokens from "@/pages/Tokens";
import TokenDetail from "@/pages/TokenDetail";
import Contracts from "@/pages/Contracts";
import Governance from "@/pages/Governance";
import Admin from "@/pages/Admin";
import Watchlist from "@/pages/Watchlist";
import { getChainInfo } from "@/lib/api";
import { WalletProvider } from "@/contexts/WalletContext";

function App() {
  const [chainInfo, setChainInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => getChainInfo().then((d) => alive && setChainInfo(d)).catch(() => {});
    load();
    const id = setInterval(load, 5000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <BrowserRouter>
      <WalletProvider>
        <Layout chainInfo={chainInfo}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/blocks" element={<Blocks />} />
            <Route path="/txs" element={<Transactions />} />
            <Route path="/block/:id" element={<BlockDetail />} />
            <Route path="/tx/:hash" element={<TxDetail />} />
            <Route path="/address/:addr" element={<AddressDetail />} />
            <Route path="/tokens" element={<Tokens />} />
            <Route path="/token/:addr" element={<TokenDetail />} />
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/validators" element={<Validators />} />
            <Route path="/governance" element={<Governance />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/network" element={<Network />} />
          </Routes>
        </Layout>
      </WalletProvider>
    </BrowserRouter>
  );
}

export default App;
